import React, { JSX } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { AiOutlineHome, AiOutlineUser, AiOutlineUnorderedList, AiOutlineCreditCard, AiOutlineFileText, AiOutlineBarChart, AiOutlineSetting, AiOutlineClockCircle } from "react-icons/ai";
import { BiLineChart } from "react-icons/bi";

type MenuIcon = JSX.Element;

type MenuItem = {
  label: string;
  path: string;
  requiresAuth?: boolean;
  icon: MenuIcon;
};

const LeftMenu: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth0();

  // Liste des items du menu avec icônes
  const menuItems: MenuItem[] = [
    { label: "Accueil", path: "/", icon: <AiOutlineHome className="text-xl" /> },
    { 
      label: "Profile", 
      path: "/profile", 
      requiresAuth: true, 
      icon: <AiOutlineUser className="text-xl" />
    },
    { 
      label: "Actions", 
      path: "/stocks", 
      requiresAuth: true, 
      icon: <BiLineChart className="text-xl" />
    },
    { 
      label: "Liste de transactions", 
      path: "/transactions", 
      requiresAuth: true, 
      icon: <AiOutlineUnorderedList className="text-xl" />
    },
    { 
      label: "Comptes bancaires", 
      path: "/accounts", 
      requiresAuth: true, 
      icon: <AiOutlineCreditCard className="text-xl" />
    },
    {
      label: "Catégories",
      path: "/categories",
      requiresAuth: true,
      icon: <AiOutlineCreditCard className="text-xl" />
    },
    {
      label: "Opérations automatiques",
      path: "/automatic-operations",
      requiresAuth: true,
      icon: <AiOutlineClockCircle className="text-xl" />
    },
    { 
      label: "Bilan", 
      path: "/bilan", 
      requiresAuth: true, 
      icon: <AiOutlineFileText className="text-xl" />
    },
    { 
      label: "Stats", 
      path: "/stats", 
      requiresAuth: true, 
      icon: <AiOutlineBarChart className="text-xl" />
    },
    { 
      label: "Admin", 
      path: "/admin", 
      requiresAuth: true, 
      icon: <AiOutlineSetting className="text-xl" />
    },
    // Ajouter d'autres éléments de menu au besoin
  ];

  return (
    <div className="bg-gray-900 text-gray-100 w-64 h-screen fixed left-0 top-0 overflow-y-auto shadow-md">
      <div className="p-6 border-b border-gray-800">
        <div className="text-2xl font-bold text-blue-400">Money App</div>
      </div>
      <nav className="p-4">
        <ul className="space-y-3">
          {menuItems.map((item) => {
            // N'afficher les éléments nécessitant l'authentification que si l'utilisateur est connecté
            if (item.requiresAuth && !isAuthenticated) return null;
            
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? "bg-blue-600 text-white font-medium shadow-md"
                      : "text-gray-300 hover:bg-gray-800 hover:text-white"
                  }`}
                >
                  <span className="mr-3">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default LeftMenu;
